 @if (isLoggedIn) {
    <div class="sidebar-desktop" [class.collapsed]="isCollapsed">
      <div class="sidebar-profile">
        <div class="sidebar-logo" style="margin: 0 auto 16px auto;">
          <img src="/header/png/Ribera_logo.svg" alt="Ribera del Rio" />
        </div>
        <div class="expand-container">
          <div class="expand-button"> 
            <img src="/header/png/expand_icon.png" alt="Recompensas" (click)="collapseOrExpand()" tabindex="0" (keypress)="collapseOrExpand()"/>
          </div>
        </div>
        
        <lib-promoters-profile-ui [isCollapsed]="isCollapsed" ></lib-promoters-profile-ui>
        
      </div>
      <!-- <nav class="sidebar-links scroll-container">
        <a 
          class="sidebar-link active" 
          routerLink="/dashboard"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/more_horizontal_16px.svg" alt="Inicio" style="margin: 0 12px;" />
          <span>Inicio</span>
        </a>

        <a 
          class="sidebar-link" 
          routerLink="/data"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/user-square.svg" alt="Mis datos" style="margin: 0 12px;" />
          <span>Mis datos</span>
        </a>

         @if(!isCollapsed){
          <p-accordion value="0">
            <p-accordion-panel value="0">
              <p-accordion-header>
                <div class="accordion-title">
                  <img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/fi-rr-bed.svg" alt="Mis datos" style="margin: -2px 7px -2px 12px;" />
                  Reservas
                </div>
              </p-accordion-header>
              <p-accordion-content>
                <div class="sidebar-sublink"
                  routerLink="/bookings"
                  [class.active]="isBookingActive"
                >
                  Disponibles
                </div>
                <div class="sidebar-sublink"
                    routerLink="/member-booking-feature/active-bookings"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                >
                  Reservados
                </div>
                <div class="sidebar-sublink"
                    routerLink="/member-booking-feature/booking-history"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                >
                  Histórico
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        } @else {
          <a 
            class="sidebar-link" 
            routerLink="/bookings"
            [class.active]="isBookingCollapsedActive"
          >
            <img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/fi-rr-bed.svg" alt="Reservas" style="margin: 0 12px;" />
            <span>Reservas</span>
          </a>
        }

        <a 
          class="sidebar-link" 
          routerLink="/benefits"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/user-double.svg" alt="Beneficios" style="margin: 0 12px;" />
          <span>Beneficios</span>
        </a>

        <a 
          class="sidebar-link" 
          routerLink="/dashboard/rewards"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/cup.svg" alt="Recompensas" style="margin: 0 12px;" />
          <span>Recompensas</span>
        </a>

        <a 
          class="sidebar-link" 
          routerLink="/dashboard/wallet"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/wallet.svg" alt="Mi wallet" style="margin: 0 12px;" />
          <span>Mi wallet</span>
        </a>

        
        
      </nav> -->
      <nav class="sidebar-links scroll-container">
        
          @for (item of navbar; track $index) {
            <a class="sidebar-link"  
            [class.active]="item.key === active" 
            (click)="handleLinkClick($event, item, popover)" 
            (keydown.enter)="handleLinkClick($event, item, popover)"
            pTooltip="{{ item.label }}"
            tooltipPosition="right"
            [tooltipDisabled]="!isCollapsed"
            tooltipStyleClass="sidebar-tooltip" 
            tabindex="0"
            [routerLink]="item.path"
            routerLinkActive="active"
            >
              <div class="link-label" [ngStyle]="{'display': isCollapsed ? 'flex' : 'block'}">
                <img style="margin: 0 12px;" [src]="item.icon" [alt]="item.label">
                <span>{{ item.label }}</span>
              </div>
              @if(item.children && item.children.length > 0){
              <img [ngStyle]="{'display': isCollapsed ? 'none' : 'block'}" [src]="item.expanded ? '/member/dashboard/arrow-up.svg' : '/member/dashboard/arrow-down.svg'" alt="Toggle Submenu" class="icon icon-menu"/>
              }
            </a>
            
            <ul class="submenu" [class.show]="item.expanded">
              @for (child of item.children; track $index) {
                <li [routerLinkActiveOptions]="{ exact: true }" (click)="navigate(child.path); $event.stopPropagation();"  (keydown.enter)="navigate(child.path); $event.stopPropagation();" tabindex="0"  routerLinkActive="active-link">
                  <a [routerLink]="child.path" class="icon_label" >
                    <div class="submenu-labels" [ngStyle]="{'display': isCollapsed ? 'none' : 'flex'}" *ngIf="!isCollapsed">
                      <span>{{child.label}}</span>
                      <!-- <small *ngIf="child.label">{{ child.label }}</small> -->
                    </div>
                  </a>
                </li>
              }
            </ul>

            <p-popover #popover styleClass="sidebar-popover">
              <ul class="submenu-float">
                @for (child of item.children; track $index) {
                  <li routerLinkActive="active-link">
                    <a
                      [routerLink]="child.path"
                      (click)="popover.hide(); navigate(child.path);"
                    >
                      {{ child.label }}
                    </a>
                  </li>
                }
              </ul>
            </p-popover>
          }

      </nav>

      <div class="sidebar-link link-logout" style="width: 100%; padding: 1.5rem; justify-content: start;" (click)="logoOut()" tabindex="0" (keydown.enter)="logoOut()">
          <img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/logout.svg" alt="Recompensas" style="margin: 0 12px;" />
          <span class="logout-label">Cerrar sesión</span>
        </div>
    </div>
}



<!-- <section>
  <img class="logo" src="shell/Ribera_logo.svg" alt="logo">
  <div class="divider"></div>
  
  <section class="overflow">
    <lib-promoters-profile-ui></lib-promoters-profile-ui>
    
    <nav>
      <ul>
        @for (item of navbar; track $index) {
          <li [class.active]="item.key === active" (click)="navigate(item.path)" (keydown.enter)="navigate(item.path)"  tabindex="0">
            <img [src]="item.icon" [alt]="item.label">
            <span>{{ item.label }}</span>
          </li>
        }
      </ul>
    </nav>
  </section>
  
  <div class="bottom" tabindex="1" (click)="logoOut()" (keydown.enter)="logoOut()">
    <div class="divider"></div>
    <div class="logout">
      <img src="shell/navbar/logout.svg" alt="Cerrar sesión">
      <span>Cerrar sesión</span>
    </div>
  </div>
</section> -->